import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from 'index/AuthProvider';
import VideoPlayer from 'componentsV2/VideoPlayer';
import { VIDEO_TYPE_WATCH } from 'helpers/ContentHelper';
import { helperGetApiHeaders, helperGetApiRouteById, apiErrorHandler } from 'helpers/ApiHelper';
import axios from 'axios';

const WatchV2 = ({ routeParams }) => {
  const { videoId } = routeParams;
  const { accessToken, deviceId } = useAuth();
  const [video, setVideo] = useState(null);

  useEffect(() => {
    const pageType = 'videoDetail';
    axios
      .get(
        helperGetApiRouteById(pageType, videoId, '{videoId}'),
        helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
      )
      .then(results => {
        const panels = results?.data?.panels?.member;
        const videoPanel = panels?.[0]?.items?.member?.[0];
        setVideo(videoPanel);
      })
      .catch(errors => {
        apiErrorHandler(errors);
      });
  }, [accessToken, deviceId, videoId]);

  return <div>{video && <VideoPlayer video={video} type={VIDEO_TYPE_WATCH} />}</div>;
};

WatchV2.propTypes = {
  routeParams: PropTypes.shape({}),
};

export default WatchV2;
